/**
 * Regelversion 12, Stufe „Neu im Bundestag“: Gesetzentwürfe starten mit einer empfohlenen Einstellung.
 * Gesucht wird eine Einstellung, die zum eigenen Programm und zu den Koalitionspartnern passt, im Bundestag
 * eine Mehrheit hat und die Schuldenbremse nicht reißt. Zieht keinen Zufall.
 */
import { S } from './state';
import { score, PA, satWith } from './rules';
import { PARTIES } from '../content/parties';
import { axes } from './axes';
import { btVote } from './govern';
import { needFor } from './longterm';
import { debtLimit } from './budget';
import { draftFx } from './novelle9';

export function recommend(T: any, iss: string, tpl: number, p0: Record<string, any>): Record<string, any> {
  if (!T || T.custom) return p0;
  const p: Record<string, any> = { ...p0 };
  const val = (q: Record<string, any>): number => {
    let fx: any; try { fx = draftFx(T, iss, tpl, q, null); } catch { return -9; }
    const pos = fx.pos || {}, ys = score('YOU', pos);
    const ps = S.partners.length ? S.partners.reduce((s: number, x: string) => s + score(x, pos), 0) / S.partners.length : ys;
    let v = ys + ps * .8 + (fx.sev || 0) / 60;
    try { if (btVote(pos).yes >= needFor(fx)) v += .6; } catch { /* ohne Bundestag */ }
    if (S.saldo + (fx.b || 0) < debtLimit()) v -= .5;
    return v;
  };
  for (let k = 0; k < 2; k++) for (const pa of T.ps || []) {
    if (pa.id === 'title' || pa.id === 'blocks') continue;
    const vals = pa.k === 'r' ? [pa.min, Math.round((pa.min + pa.max) / 2 / pa.st) * pa.st, pa.max, p0[pa.id]] : pa.k === 'c' ? pa.o.map((_: string, i: number) => i) : [0, 1];
    let best = p[pa.id], bs = -99;
    for (const v of vals) { if (v == null) continue; p[pa.id] = v; const s = val(p); if (s > bs + 1e-6) { bs = s; best = v; } }
    p[pa.id] = best;
  }
  return p;
}
export const recommendNote = () => `Empfohlene Einstellung: passt zu eurem Programm${S.partners.length ? ` und zu ${S.partners.map(PA).join(', ')}` : ''}, hat nach heutigem Stand eine Mehrheit und hält die Schuldenbremse ein, soweit möglich.`;

/** Koalitionsvertrag: kleinster Kompromiss, mit dem alle Partner unterschreiben (schrittweise Annäherung). */
export function suggestContract(): Record<string, number> {
  const ag: Record<string, number> = { ...(S.agree || S.you) };
  for (let step = 0; step < 40; step++) {
    const open = S.partners.map((p: string) => ({ p, gap: PARTIES[p].prag - satWith(p, ag) })).filter((x) => x.gap > 0).sort((a, b) => b.gap - a.gap);
    if (!open.length) break;
    const p = open[0].p, P = PARTIES[p];
    let best: string | null = null, bw = 0;
    for (const a of axes()) { const d = (P.pos[a] ?? 0) - ag[a]; const w = (P.w?.[a] ?? 1) * Math.abs(d) / Math.max(.3, (S as any).youW?.[a] ?? 1); if (Math.abs(d) >= .5 && w > bw) { bw = w; best = a; } }
    if (!best) break;
    ag[best] = Math.round(ag[best] + Math.sign((P.pos[best] ?? 0) - ag[best]));
  }
  return ag;
}
